import { useEffect } from "react";
import { Client } from "../../prismic1";
import SliceZone from "next-slicezone";
import Prismic from "prismic-javascript";
import { useGetStaticProps } from "next-slicezone/hooks";
import { fetchAdditionalData } from "../../utils/fetch-additional-data";
import { AdditionalDataProvider } from "../../utils/additional-data-context";
import { useLayout } from "../../utils/layout-context";
import resolver from "../../sm-resolver.js";
import EventDetailsHero from "../../components/EventDetailsHero";
import { getLanguage, getExtensionLanguage } from "../../lib/getLanguage";
import Head from "../../components/Head";
import errorService from '../../services/error/error-service'
const Event = (props) => {

  const { data, eventHero,uid } = props;
  const { setHeaderColor } = useLayout();

  useEffect(() => {
    if (data) {
      setHeaderColor(data.headercolor);
    }
  }, [data]);

  return (
    <>
      <Head data={data} canonical={`/event/${uid}`} />
      <AdditionalDataProvider value={props.additionalData}>
        {eventHero && (
          <EventDetailsHero eventHeroData={eventHero}></EventDetailsHero>
        )}
        <SliceZone {...props} resolver={resolver} />
      </AdditionalDataProvider>
    </>
  );
};

export async function getStaticProps({
  preview = null,
  previewData = {},
  params,
  locale,
}) {
  const client = Client();
  const languageObject = getLanguage(locale);
  const language = await languageObject.prismicLanguage.toLowerCase();
  const sliceMachine = useGetStaticProps({
    client,
    params: {
      fetchLinks: [
        "event.title",
        "event.subtitle1",
        "event.subtitle2",
        "event.price_text",
        "event.register_button_text",
        "event.register_button_link",
        "event.watch_button_text",
        "event.featured_image",
        "event.price_text",
        "event.upcoming_or_past",
      ],
      lang: language,
    },
    type: "event",
    uid: ({ params }) => params.uid,
  });

  const eventHero = await client.getByUID("event", params.uid, {
    lang: language,
  });

  if (!eventHero?.data){
    return errorService.notFoundResponse
  } 

  const { props } = await sliceMachine({ preview, previewData, params });
  const additionalData = await fetchAdditionalData(
    props.slices,
    params.uid,
    language
  );

  return {
    props: {
      ...props,
      additionalData,
      eventHero,
    },
  };
}

export async function getStaticPaths() {
  const client = Client();

  const allEvents = await client.query(
    Prismic.Predicates.at("document.type", "event"),
    { lang: "*" }
  );
  const paths = allEvents.results.map((node) => {
    const languageObject = getExtensionLanguage(node.lang);
    const language = languageObject.prismicLanguage.toLowerCase();
    return {
      params: {
        uid: node.uid,
      },
      locale: language,
    };
  });

  return {
    paths,
    fallback: 'blocking',
  };
}
export default Event;
